import { Text } from '@qga/roo-ui/components';

import formatDate from '@/lib/date/format';

// eg. Sunday, 8 June 2025
const formatDateRangeSR = formatDate('EEEE, d MMMM yyyy');
// eg. Sun, 8 Jun 2025
const formatDateRangeValue = formatDate('EEE, d MMM yyyy');

export const ReturnFlightDateDisplay = ({
  departureDate,
  returnDate,
}: {
  departureDate: string | undefined;
  returnDate: string | undefined;
}) => {
  if (!departureDate || !returnDate) return null;

  return (
    <Text
      fontSize="sm"
      color="greys.steel"
      aria-label={`from ${formatDateRangeSR(departureDate)} to ${formatDateRangeSR(returnDate)}`}
    >
      {formatDateRangeValue(departureDate)} – {formatDateRangeValue(returnDate)}
    </Text>
  );
};
